export const NOTIFICATION_STATES = {
  SUCCESS: 'success',
  ERROR: 'error',
  INFO: 'info',
  WARNING: 'warning'
};

export default NOTIFICATION_STATES;
